<template>
  <div>
    <PageHead title="死亡人员列表"></PageHead>
    <div class="query">
      <div class="query-top">
        <div class="query-top-item">
          <div class="query-top-lable">姓名：</div>
          <a-input
            allowClear
            placeholder="请输入姓名"
            class="w200"
            v-model="queryForm.fullName"
          />
          <div class="query-top-lable" :style="{ marginLeft: '30px' }">
            身份证号：
          </div>
          <a-input
            allowClear
            placeholder="请输入身份证号"
            class="w200"
            v-model="queryForm.idCardNumber"
            @blur="idCardNumberBlur"
          />
          <a-button
            :style="{ marginLeft: '50px' }"
            type="primary"
            @click="subMit()"
            :loading="loading"
          >
            查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel()">
            取消
          </a-button>
          <!-- <a-button
            :icon="unfold ? 'up' : 'down'"
            :style="{ marginLeft: '10px' }"
            type="link"
            @click="() => (unfold = !unfold)"
          >
            {{ unfold ? "收起" : "展开" }}</a-button
          > -->
        </div>
        <template v-if="unfold">
          <blank height="12"> </blank>
          <div class="query-top-item2">
            <div class="query-top-select">
              <div class="query-cont">
                <div class="query-view mr20">
                  <div class="query-view-lable">性别：</div>
                  <a-select
                    allowClear
                    class="w200"
                    placeholder="不限"
                    v-model="queryForm.sex"
                  >
                    <a-select-option value="男"> 男 </a-select-option>
                    <a-select-option value="女"> 女 </a-select-option>
                  </a-select>
                </div>
                <div class="query-view mr20">
                  <div class="query-view-lable">民族：</div>
                  <a-input
                    allowClear
                    placeholder="请输入民族"
                    class="w200"
                    v-model="queryForm.nation"
                  />
                </div>
                <div class="query-view">
                  <div class="query-view-lable">政治面貌：</div>
                  <a-select
                    allowClear
                    class="w200"
                    placeholder="不限"
                    v-model="queryForm.politicalType"
                  >
                    <a-select-option
                      v-for="item in politicalTypeList"
                      :value="item.valuename"
                      :key="item.id"
                    >
                      {{ item.keyname }}</a-select-option
                    >
                  </a-select>
                </div>
              </div>
              <blank height="30"> </blank>
              <div class="query-cont">
                <!-- <div class="query-view mr20">
                  <div class="query-view-lable">户口性质：</div>
                  <a-select
                    allowClear
                    class="w200"
                    placeholder="不限"
                    v-model="queryForm.registeredNature"
                  >
                    <a-select-option
                      v-for="item in registeredNatureList"
                      :value="item.valuename"
                      :key="item.id"
                    >
                      {{ item.keyname }}</a-select-option
                    >
                  </a-select>
                </div> -->
                <div class="query-view mr20">
                  <div class="query-view-lable">死亡时间：</div>
                  <a-range-picker
                    class="w200"
                    @change="dateStringChange"
                    v-model="deathTimeData"
                    format="YYYY.MM.DD"
                  />
                </div>
                <div class="query-view">
                  <div class="query-view-lable">死亡档案号：</div>
                  <a-input
                    allowClear
                    placeholder="请输入死亡档案号"
                    class="w200"
                    v-model="queryForm.deathNumber"
                  />
                </div>
              </div>
              <blank height="20"> </blank>
            </div>
          </div>
        </template>
        <div class="mt20 mb20 search-btns">
          <a-button type="primary" icon="plus" @click="add()"> 新增</a-button>
          <a-button
            type="primary"
            :style="{ marginLeft: '8px' }"
            @click="showModal(1)"
            icon="swap"
          >
            批量导入</a-button
          >
        </div>
        <blank height="10"> </blank>
      </div>
      <blank height="20"> </blank>
      <div class="query-content">
        <prompts>
          <span v-if="isTotal == 1">系统共有{{ total }}条人事数据</span>
          <span v-else>符合此查询条件的有{{ total }}条人事数据</span>
          <a-button
            type="primary"
            size="small"
            class="ml20"
            @click="showModal(2)"
            >批量导出</a-button
          >
        </prompts>
        <blank height="20"> </blank>
        <!-- 花名册列表 -->
        <a-table
          :pagination="false"
          :columns="columns"
          :data-source="personList"
          :loading="loading"
          :row-key="(record) => record.id"
        >
          <span slot="index" slot-scope="text, record, index">
            {{ index + 1 + (page - 1) * 10 }}
          </span>
          <span slot="position" slot-scope="text">{{
            getByTypeName(text, positionList)
          }}</span>
          <div slot="action" slot-scope="text, record">
            <a-button type="link" class="btn-link" @click="goDetial(record.id)">
              查看
            </a-button>
            <!-- <a-divider type="vertical" />
            <a-button type="link" class="btn-link" @click="setpop(record.id)">
              减员
            </a-button> -->
            <a-divider type="vertical" />
            <a-button type="link" class="btn-link" @click="add(record.id)">
              修改
            </a-button>
            <a-divider type="vertical" />
            <a-button type="link" class="btn-link" @click="history(record.id)">
              历史记录
            </a-button>
          </div>
        </a-table>
        <div class="pagination">
          <a-pagination
            :current="page"
            :default-current="page"
            :total="total"
            :pageSize="size"
            @change="pageChange"
          />
        </div>
      </div>
      <appfloor></appfloor>
      <a-modal v-model="visible3" title="配置到期提醒" @ok="RemindIt">
        <prompts> 选择时间范围，设置人事合同到期提醒。 </prompts>
        <blank height="48"> </blank>
        <div class="operating-day">
          <a-switch v-model="expireRemind" /> 合同到期提醒
        </div>
        <blank height="15"> </blank>
        <div class="operating-day">
          人事合同到期前
          <span class="day-num">{{ expireRemindDay }} </span>
          天，发系统消息提醒。
        </div>
        <blank height="51"> </blank>
        <div class="operating-day">
          <a-switch v-model="yearsRemind" /> 合同年限提醒
        </div>
        <blank height="15"> </blank>
        <div class="operating-day">
          人事合同年满一年前
          <span class="day-num">{{ contractAgeRemindDay }} </span>
          天，发系统消息提醒。
        </div>
        <blank height="20"> </blank>
      </a-modal>
      <a-modal v-model="visible1" title="批量操作" :footer="null">
        <prompts>
          操作步骤
          <span slot="two">
            1. 下载Excel导入模版。 2. 填写信息到Excel模版。 3.
            将填写好信息的Excel回传到系统<blank height="8"> </blank
          ></span>
        </prompts>
        <div class="xlsx">
          <a-icon type="link" />
          死亡人员花名册模板.xlsx
        </div>
        <div class="xlsx-btn">
          <a-button
            icon="vertical-align-bottom"
            type="primary"
            @click="downTemplate"
          >
            下载模板</a-button
          >

          <a-upload
            name="file"
            :multiple="false"
            :headers="headers"
            action="#"
            :fileList="bfileList"
            :showUploadList="false"
            :beforeUpload="beforeUpload"
            @change="uploading"
          >
            <a-button icon="vertical-align-top" type="primary">
              上传Excel</a-button
            >
          </a-upload>
        </div>
        <blank height="100"> </blank>
      </a-modal>
      <a-modal
        v-model="visible2"
        title="批量导出"
        @ok="ExportList"
        width="600px"
      >
        <prompts>
          请选择导出字段，姓名和身份证号为必选字段，其他字段可以手选
        </prompts>

        <div class="operating-checkbox">
          <a-checkbox v-model="checkAll" @change="onCheckAllChange">
            全选
          </a-checkbox>
          <blank height="10"> </blank>
          <a-checkbox-group
            v-model="excelHeader"
            :options="plainOptions"
            @change="excelHeaderonChange"
          >
            <a-checkbox
              v-for="(item, index) in plainOptions"
              :key="index"
              :value="item.value"
            >
              {{ item.label }}
            </a-checkbox>
          </a-checkbox-group>
        </div>
      </a-modal>
      <a-modal
        v-model="ispop"
        title="减员操作"
        @ok="depletion"
        :confirm-loading="confirmLoading"
      >
        <prompts> 请选择减员原因，并填写减员备注信息 </prompts>
        <div class="dep-form">
          <div class="dep-form-item">
            <div class="dep-form-lable">减员原因：</div>
            <a-radio-group v-model="delData.positionStatus">
              <template v-for="item in positionStatusList">
                <a-radio
                  :value="item.valuename"
                  :key="item.id"
                  v-if="item.valuename !== '1001'"
                >
                  {{ item.keyname }}
                </a-radio>
              </template>
            </a-radio-group>
          </div>
          <blank height="25"> </blank>
          <div class="dep-form-item">
            <div class="dep-form-lable">减员备注：</div>
          </div>
          <div class="dep-form-item">
            <a-input
              v-model="delData.cause"
              type="textarea"
              class="w500"
              :auto-size="{ minRows: 4, maxRows: 6 }"
            />
          </div>
        </div>
      </a-modal>
      <a-modal
        v-model="ishistory"
        title="历史修改记录"
        :footer="null"
        :width="800"
      >
        <a-table
          :pagination="false"
          :columns="historyColumns"
          :data-source="historyList"
          :row-key="(record) => record.fromVersion"
        >
          <div slot="action" slot-scope="text, record">
            <a-button
              type="link"
              class="btn-link"
              @click="goHistoryDetial(record.id, record.version)"
            >
              查看
            </a-button>
          </div>
        </a-table>
        <div class="pagination">
          <a-pagination
            :current="historyPage"
            :default-current="historyPage"
            :total="historyTotal"
            :pageSize="historySize"
            @change="historyPageChange"
          />
        </div>
      </a-modal>
      <a-modal
        v-model="importData"
        title="导入失败"
        @ok="importDataOk"
        :width="600"
      >
        <div class="import-scrollY">
          <div
            class="import-formCont"
            v-for="(i, index) in importList"
            :key="index"
          >
            {{ i }}
          </div>
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
import {
  getDeadlist,
  updatePositionStatus,
  deathPersonnelManagerHistoryList,
  deathPersonnelManagerImportDeathPersonnelManager,
  getTreeList,
  deathPersonnelManagerListExport,
  setRemind,
  getRemind,
  personnelList,
  deathPersonnelImportTemplate
} from '../api/api'
import { mapState, mapActions } from 'vuex'
import { validateIdCard } from '@/assets/js/auth.js'
import staticData from '../staticData/staticData' // 人事管理模块 静态资源
export default {
  data() {
    return {
      confirmLoading: false,
      importData: false, //导入错误信息
      columns: staticData.deathsColumns,
      historyColumns: staticData.deathsHistoryColumns,
      historyList: [], //历史版本列表
      historyPage: 1,
      historyTotal: 0,
      historySize: 5,
      historyId: '', // 被查看历史版本的人id
      ishistory: false, // 历史版本弹出
      visible1: false,
      visible2: false,
      visible3: false,
      ispop: false, //减员
      delId: '', // 当前减员的id
      delData: {}, // 减员操作信息
      queryForm: {}, //搜索项
      unfold: true, // 搜索框是否展开
      organizationIds: [], // 选中的部门
      personList: [], // 人事花名册列表
      treeData: [], // 组织机构树
      excelHeader: [], //导出对应字段value
      excelHeaderKey: [], //导出对应标题label
      checkAll: false,
      replaceFields: {
        key: 'id',
        value: 'id',
        children: 'treeList',
        title: 'organizationName'
      },
      expireRemind: false, //到期提醒
      yearsRemind: false, //	年限提醒
      expireRemindDay: 30, //人事花名册合同到期提醒设置天数
      contractAgeRemindDay: 30, //人事花名册年限到期提醒设置天数
      isTotal: 1, // 1全部  2 搜索
      page: 1,
      total: 0,
      size: 10,
      loading: false,
      importList: [],
      bfileList: [],
      headers: {
        Authentication: localStorage.getItem('token')
      },
      dayFormat: 'YYYY.MM.DD',
      startAge: '22',
      endAge: '59',
      plainOptions: staticData.deathsPlainOptions, // 死亡人员管理 批量导出头
      deathTimeData: []
    }
  },
  created() {
    this.getByType()
    this.load(1)
  },
  computed: {
    ...mapState({
      // plainOptions: (state) => state.app.plainOptions, //Excel导出头
      positionList: (state) => state.bytype.positionList, //行政职务
      positionLevelList: (state) => state.bytype.positionLevelList, //职级
      politicalTypeList: (state) => state.bytype.politicalTypeList, //政治面貌
      contractTypeList: (state) => state.bytype.contractTypeList, //劳动合同类型
      educationList: (state) => state.bytype.educationList, //学历
      registeredNatureList: (state) => state.bytype.registeredNatureList, //户口性质
      positionStatusList: (state) => state.bytype.positionStatusList //减员原因
    }),
    allexcelHeader: function () {
      // `this` 指向 vm 实例
      // 全选
      let Header = []
      for (const value of this.plainOptions) {
        Header.push(value.value)
      }
      return Header
    }
  },
  methods: {
    ...mapActions([
      'getposition',
      'getpositionLevel',
      'getpoliticalType',
      'getcontractType',
      'geteducation',
      'getregisteredNature',
      'getpositionStatus'
    ]),
    //通过字典值过去字典名
    getByTypeName(value, list) {
      let byType = list.find((item) => {
        return item.valuename == value
      })
      if (byType) {
        return byType.keyname
      } else {
        return value
      }
    },
    // 获取当前页面所需字典表
    getByType() {
      //获取组织机构
      getTreeList().then((res) => {
        this.treeData = res.data.data
      })
      //减员原因
      this.getpositionStatus()
      //行政职务
      this.getposition()
      //职级
      this.getpositionLevel()
      //政治面貌
      this.getpoliticalType()
      //劳动合同类型
      this.getcontractType()
      //学历
      this.geteducation()
      //户口性质
      this.getregisteredNature()
    },
    cancel() {
      //取消
      this.queryForm = {}
      this.deathTimeData = []
      this.organizationIds = []
    },
    subMit() {
      //搜索
      this.page = 1
      this.load(2)
    },
    load(isTotal) {
      // this.loading = truedeathTimeData
      this.loading = true
      let params = this.queryForm
      params.page = this.page
      params.size = this.size

      if (this.organizationIds.length > 0) {
        // 部门id转字符串拼接
        this.queryForm.organizationIds = this.organizationIds.join(',')
      }
      if (this.deathTimeData.length > 0) {
        //选择了时间范围
        params.deathTimeStart = this.deathTimeData ? this.deathTimeData[0] : ''
        params.deathTimeEnd = this.deathTimeData ? this.deathTimeData[1] : ''
      }
      getDeadlist(params).then((res) => {
        this.loading = false
        if (isTotal) {
          this.isTotal = isTotal
        }
        if (res.data.code == 0) {
          this.personList = res.data.data
          this.total = res.data.count
        }
      })
    },
    add(id) {
      this.$router.push({
        path: '/TheDeadAdd',
        query: {
          id
        }
      })
    },
    showModal(type) {
      if (type == 1) {
        this.visible1 = true
      } else if (type == 2) {
        this.visible2 = true
      } else {
        // 弹出提醒设置
        getRemind().then((res) => {
          // 获取当前用户设置的提醒
          if (res.data.code == 0) {
            this.expireRemind = res.data.data.expireRemind ? true : false
            this.yearsRemind = res.data.data.yearsRemind ? true : false
          }
        })
        personnelList().then((res) => {
          // 获取提醒天数
          if (res.data.code == 0) {
            this.expireRemindDay = res.data.data.expireRemindDay
            this.contractAgeRemindDay = res.data.data.contractAgeRemindDay
          }
        })

        this.visible3 = true
      }
    },
    history(id) {
      //查看历史记录
      this.historyId = id
      this.historyLoad()
      this.ishistory = true
    },
    historyLoad() {
      // 获取历史版本列表 deathPersonnelManagerHistoryList
      let params = {
        id: this.historyId,
        page: this.historyPage,
        size: this.historySize
      }
      deathPersonnelManagerHistoryList(params).then((res) => {
        if (res.data.code == 0) {
          this.historyList = res.data.data
          this.historyTotal = res.data.count
        }
      })
    },

    RemindIt() {
      // 到期提醒设置
      let params = {}
      params.expireRemind = this.expireRemind ? 1 : 0
      params.yearsRemind = this.yearsRemind ? 1 : 0
      setRemind(params).then((res) => {
        if (res.data.code == 0) {
          this.$message.success('设置成功')
          this.visible3 = false
        }
      })
    },
    onCheckAllChange(e) {
      if (e.target.checked) {
        // 全选
        this.excelHeader = this.allexcelHeader
      } else {
        this.excelHeader = []
      }
    },
    excelHeaderonChange() {
      //判断是否全选
      if (this.excelHeader.length == this.allexcelHeader.length) {
        //全部选择
        this.checkAll = true
      } else {
        this.checkAll = false
      }
    },
    // 批量导出
    ExportList() {
      let Header = []
      for (const value of this.excelHeader) {
        let name = this.getexcelHeaderKey(value)
        Header.push(name.label)
      }
      this.excelHeaderKey = Header
      let params = this.queryForm
      params.excelHeader = 'fullName,idCardNumber,' + this.excelHeader.join(',') // 对应字段
      params.excelHeaderKey = '姓名,身份证号,' + this.excelHeaderKey.join(',') // 标题
      if (this.organizationIds.length > 0) {
        // 部门id转字符串拼接
        this.queryForm.organizationIds = this.organizationIds.join(',')
      }
      delete params.size
      delete params.page
      // 导出
      this.$message.loading('导出中···', 0)
      // return
      deathPersonnelManagerListExport(params).then((response) => {
        this.$message.destroy()
        this.$message.success('导出成功')
        this.visible2 = false

        // resolve(response.data);
        let blob = new Blob([response.data], {
          type: 'application/vnd.ms-excel'
        })

        let fileName = '死亡人员花名册.xlsx'
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName)
        } else {
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          //释放内存
          window.URL.revokeObjectURL(link.href)
        }
      })
    },
    getexcelHeaderKey(value) {
      // 根据excelHeader获取excelHeaderKey
      return this.plainOptions.find((obj) => {
        if (obj.value == value) {
          return obj
        }
      })
    },
    downTemplate() {
      //下载模板
      deathPersonnelImportTemplate().then((response) => {
        // resolve(response.data);
        let blob = new Blob([response.data], {
          type: 'application/vnd.ms-excel'
        })

        let fileName = '死亡人员花名册模板.xlsx'
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName)
        } else {
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          //释放内存
          window.URL.revokeObjectURL(link.href)
        }
      })
    },
    beforeUpload(file, fileList) {
      return false
    },
    uploading(file) {
      this.$message.loading('导入中···', 0)
      let formDataChildren = new FormData()
      formDataChildren.append('file', file.file)
      deathPersonnelManagerImportDeathPersonnelManager(formDataChildren).then(
        (res) => {
          if (res.data.code == 0) {
            this.$message.destroy()
            this.visible1 = false
            this.$success({
              title: '导入成功',
              // JSX support
              okText: '确定',
              content: res.data.msg,
              onOk: () => {
                this.page = 1
                this.load(1)
              }
            })
          } else if (res.data.code == 2) {
            //
            this.$message.destroy()
            this.importList = res.data.data
            this.importData = true
          }
        }
      )
    },
    importDataOk() {
      this.importData = false
    },
    setpop(id) {
      //减员弹出
      this.delId = id
      this.ispop = true
    },
    depletion() {
      // 确定减员
      this.confirmLoading = true
      let params = this.delData
      params.id = this.delId
      updatePositionStatus(params).then((res) => {
        if (res.data.code == 0) {
          this.$message.success('减员操作成功')
          this.ispop = false
          this.load()
          this.confirmLoading = false
        } else {
          this.confirmLoading = false
        }
      })
    },
    goAdvancedQuery() {
      this.$router.push('/AdvancedQuery')
    },
    goDetial(id) {
      this.$router.push({
        path: '/TheDeadDetail',
        query: {
          id
        }
      })
    },
    goHistoryDetial(id, version) {
      this.$router.push({
        path: '/TheDeadDetail',
        query: {
          id,
          version
        }
      })
    },
    pageChange(pageNumber) {
      this.page = pageNumber
      this.load()
    },
    // 历史记录分页
    historyPageChange(pageNumber) {
      this.historyPage = pageNumber
      this.historyLoad()
    },
    // 身份证效验
    idCardNumberBlur() {
      if (!this.queryForm.idCardNumber) return
      let n = validateIdCard(this.queryForm.idCardNumber)
      if (!n) {
        this.queryForm.idCardNumber = ''
        this.$message.error('身份证号格式错误')
      }
    },
    dateStringChange(date, dateString) {
      // console.log(date, dateString)
      this.deathTimeData = dateString
    }
  }
}
</script>

<style lang="scss" scoped>
.query {
  margin: 24px 16px;
  .query-top {
    padding: 0 24px;
    background: #fff;
    .query-top-item {
      height: 66px;
      border-bottom: rgba(229, 229, 229, 1) 1px solid;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .query-top-lable {
        margin-right: 10px;
        width: 75px;
        color: rgba(0, 0, 0, 0.85);
        font-size: 14px;
        text-align: right;
      }
    }
    .query-top-item2 {
      //   height: 66px;
      border-bottom: rgba(229, 229, 229, 1) 1px solid;

      .query-top-select {
        width: calc(100% - 200px);
        .query-cont {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          .query-view {
            display: flex;
            align-items: center;
            justify-content: center;
            .query-view-lable {
              width: 85px;
              color: rgba(0, 0, 0, 0.65);
              font-size: 14px;
              line-height: 22px;
              text-align: right;
              margin-right: 10px;
            }
          }
        }
      }
    }
  }
  .query-content {
    padding: 24px;
    background: #fff;
  }
}

.xlsx {
  width: 204px;
  height: 22px;
  margin: 32px 25px;
  color: rgba(166, 166, 166, 1);
  font-size: 14px;
  line-height: 22px;
  text-align: left;
}
.xlsx-btn {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.operating-day {
  margin-left: 38px;
}
.day-num {
  color: rgba(255, 87, 51, 1);
  font-size: 17px;
}
.dep-form {
  width: 468px;
  margin-top: 40px;
  .dep-form-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .dep-form-lable {
      width: 70px;
      height: 21px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      line-height: 21px;
      text-align: left;
    }
  }
}
.import-scrollY {
  overflow-y: scroll;
  max-height: calc(100vh - 500px);
}
</style>
<style lang="scss">
.operating-checkbox {
  margin: 20px 10px;
  .ant-checkbox-group-item {
    margin-bottom: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PersonnelManagement/TheDead/index.vue